// Library Imports
import React, { FC } from 'react';

// Local Imports
import SideMenu from '../SideMenu';
import Header from '../Header';

type LayoutProps = {
  children: React.ReactNode;
};

const Layout: FC<LayoutProps> = ({ children }) => {
  return (
    <React.Fragment>
      <main className='flex w-[100vw] h-[100vh]'>
        {/* Side Menu */}
        <div className='bg-neutral-400 sm:min-w-[275px] sm:block hidden min-w-[150px] h-full border-1 border-red-400'>
          <SideMenu />
        </div>

        <div className='bg-white h-full w-full overflow-x-hidden'>
          {/* <Header /> */}
          <div className='h-[66px] border-b'>
            <Header />
          </div>
          {/* Body */}
          <div className='overflow-y-auto h-[calc(100vh-66px)]'>
            <React.Fragment>{children}</React.Fragment>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
};
export default Layout;
